import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
const SalesReturnComponent = loadable(
  () => import("../../components/SalesReturn")
);

const SalesReturn = () => {
  return (
    <>
      <div className={tw`flex items-center justify-between`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>Sales Return</h1>
      </div>
      <SalesReturnComponent />
    </>
  );
};
export default SalesReturn;
